import React from 'react';

import useSelect from '../../../services/hooks/UI/useSelect';
import DisplayOptions from '../Selects/DisplayOptions/DisplayOptions';
import { ReactComponent as ArrowDown } from '../../../assets/icons/ArrowDown.svg';
import { indicativePhone } from '../../../store/catalogs/indicativePhone';
import { formTypes } from '../../../store/catalogs/forms';

import classes from './Phone.module.scss';
import NumberInput from '../NumberInput/NumberInput';

const Phone = ({
  errorIndicative,
  onChangeIndicative,
  keyIndicative,
  keyNumber,
  valueIndicative,
  onChange,
  validate,
  error,
  value,
  placeholder,
  onBlur
}) => {
  const {
    open,
    divRef,
    containerBlurHandler,
    containerClickHandler,
    containerClasses,
    selectValue,
    filteredOptionsOrCreated,
    inputBlurHandler,
    closedOptions,
    inputRef,
    arrowClickHandler,
    setOptions,
    labelSelected,
    selectOptions
  } = useSelect({
    value: valueIndicative,
    options: indicativePhone,
    onChange: onChangeIndicative,
    typeSelect: formTypes.phone,
    className: classes.content,
    error: errorIndicative || error
  });
  const indicativeClass = [classes.container, classes.indicative];
  return (
    <div className={containerClasses.join(' ')}>
      <div
        className={`${indicativeClass.join(' ')} pointer`}
        name={keyIndicative}
        tabIndex={0}
        ref={divRef}
        onBlur={containerBlurHandler}
        onClick={containerClickHandler}>
        <span name={keyIndicative} className='text-ellipsis medium-16'>
          {`${selectValue.shortLabel || selectValue.label}`}
        </span>

        <ArrowDown className='select-icon' onClick={arrowClickHandler} />
      </div>

      <DisplayOptions
        key='Select'
        toogleOpenHandler={closedOptions}
        classContent='select-options'
        open={open}
        options={filteredOptionsOrCreated}
        selected={selectValue.value}
        onChange={setOptions}
        value={labelSelected}
        onBlur={inputBlurHandler}
        reference={inputRef}
        selectOptions={selectOptions}
      />

      <NumberInput
        className={classes.number}
        classNameFormat={classes.format}
        name={keyNumber}
        placeholder={'300 000 000'}
        /* error={error} */
        validated={validate}
        onChange={numberData => {
          onChange(numberData);
        }}
        value={value}
        onBlur={onBlur}
        thousandSeparator={false}
        prefix=''
      />
    </div>
  );
};

export default Phone;
